import { ArticleModel } from 'src/app/models/archive/article.model';
import { InvoiceModel } from './invoice.model';

export class InvoiceDetailModel {
  invoiceDetailId: number = 0; //Backend 
  invoiceId: number = 0;
  invoice: InvoiceModel = new InvoiceModel();
  conceptInvoicingId: number = 0;
  articleId: number = 0;
  article: ArticleModel = new ArticleModel();
  storeId: number = 0;
  sequence: number = 0; //Backend 
  swManual: boolean = false; //Se llena en el backend
  dateInitial: Date = new Date;
  dateFinal: Date = new Date;
  totalTime: number = 1;
  quantity: number = 0;
  residue: number = 0;
  unitValueWithoutDiscount: number = 0;
  discountRate: number = 0; //Backend 
  generalDiscountValue: number = 0; //Backend 
  unitValueWithDiscount: number = 0; //Backend 
  ivaRate: number = 0; //Backend 
  document: string | null = null;
  affectsInventory: boolean = false;
  quantityUnd: number = 0;
  residueUnd: number = 0; //Backend 
  debitNotesValue: number = 0; //Backend 
  creditNotesValue: number = 0; //Backend 
  totalValueWithDiscount: number = 0; //Backend 
  accountingCostCenter: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //Variables usada solo del lado del FrontEnd (formato)
  index: number = 1;

  //normalizo las fechas para que queden con hora 00:00:00.000 UTC
  //esto es necesario para que la validacion de dias funcione correctamente
  constructor() {
    this.dateInitial = this.toMidnightUTC(new Date());
    this.dateFinal = this.toMidnightUTC(new Date());
  }

  private toMidnightUTC(date: Date): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }
}